import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Component from './component'
import { openModal, closeModal } from '../../redux/modules/loginModal'

const WithData = connect(
  state => ({
    isOpen: state.loginModal.isOpen,
    component: state.loginModal.component,
    vermarktungsart: state.loginModal.marketingType,
    unlockFormSubmitted: state.unlockEstateAddress.success,
  }),
  dispatch => bindActionCreators({ openModal, closeModal }, dispatch)
)(Component)

export default WithData
